export const SEARCH_SUGGESTS = 'SEARCH_SUGGESTS';
export const SEARCH_SUGGESTS_SUCCESS = 'SEARCH_SUGGESTS_SUCCESS';
export const SEARCH_SUGGESTS_FAILURE = 'SEARCH_SUGGESTS_FAILURE';
export const CLEAR_SEARCH_SUGGESTS = 'CLEAR_SEARCH_SUGGESTS';

export const GET_FROM_SUGGESTS = 'GET_FROM_SUGGESTS';
export const GET_FROM_SUGGESTS_SUCCESS = 'GET_FROM_SUGGESTS_SUCCESS';

const SEARCH_PAGE_SIZE = 20;

export const searchSuggests = ({ query, pageSize = SEARCH_PAGE_SIZE }) => ({
  type: SEARCH_SUGGESTS,
  payload: { query, pageSize },
});

export const getFromEmailSuggests = () => ({
  type: GET_FROM_SUGGESTS,
});
